import React from 'react';
import { Box } from '@mui/material';
import MonthlyShiftSlotManagerContainer from './containers/MonthlyShiftSlotManagerContainer';
import { monthlyShiftSlotSummaryRepository } from '../../../infrastructure/repositories/MonthlyShiftSlotSummaryRepositoryImpl';
import '../../../pages/ManagementList.css';

/**
 * 月次シフト枠管理ページコンポーネント
 *
 * @description
 * 月次シフト枠管理機能のルーティングエントリポイント。
 * Infrastructure層のRepository実装をContainerに注入する（依存性逆転）。
 *
 * @returns {React.ReactElement} ページコンポーネント
 *
 * @example
 * // App.tsx でのルーティング設定
 * <Route path="/doctors/shifts/manager" element={<MonthlyShiftSlotManagerPage />} />
 */
export const MonthlyShiftSlotManagerPage: React.FC = () => {
  return (
    <Box className="management-page" sx={{ p: 0 }}>
      <MonthlyShiftSlotManagerContainer
        repository={monthlyShiftSlotSummaryRepository}
      />
    </Box>
  );
};

MonthlyShiftSlotManagerPage.displayName = 'MonthlyShiftSlotManagerPage';

export default MonthlyShiftSlotManagerPage;
